<template>
  <div class="request-list-container">
    <div class="request-list-wrapper">
      <div class="request-table">
        <div class="request-table-list request-table-border table-flex">
          <div class="column10">
            REQUEST ID
            <span class="small-text cursor-pointer"><i :class="`fas fa-long-arrow-alt-${$get($store, 'state.approvalSheet.order_by') == 'code' &&
              $get($store, 'state.approvalSheet.order_short') == 'desc'
              ? 'up'
              : 'down'
              }`
              " @click="short('code')"></i></span>
          </div>
          <div class="column15">
            Nama Vendor
            <span class="small-text cursor-pointer"><i :class="`fas fa-long-arrow-alt-${$get($store, 'state.approvalSheet.order_by') ==
              'nama_vendor' &&
              $get($store, 'state.approvalSheet.order_short') == 'desc'
              ? 'up'
              : 'down'
              }`
              " @click="short('nama_vendor')"></i></span>
          </div>
          <div class="column20 ml20">
            Tipe Request
            <span class="small-text cursor-pointer"><i :class="`fas fa-long-arrow-alt-${$get($store, 'state.approvalSheet.order_by') == 'type' &&
              $get($store, 'state.approvalSheet.order_short') == 'desc'
              ? 'up'
              : 'down'
              }`
              " @click="short('type')"></i></span>
          </div>
          <div class="column15">
            Tanggal Request
            <span class="small-text cursor-pointer"><i :class="`fas fa-long-arrow-alt-${$get($store, 'state.approvalSheet.order_by') ==
              'createdAt' &&
              $get($store, 'state.approvalSheet.order_short') == 'desc'
              ? 'up'
              : 'down'
              }`
              " @click="short('createdAt')"></i></span>
          </div>
          <div class="column15">
            Tgl Terakhir Diubah
            <span class="small-text cursor-pointer"><i :class="`fas fa-long-arrow-alt-${$get($store, 'state.approvalSheet.order_by') ==
              'updatedAt' &&
              $get($store, 'state.approvalSheet.order_short') == 'desc'
              ? 'up'
              : 'down'
              }`
              " @click="short('updatedAt')"></i></span>
          </div>
          <div class="column15 text-center">
            Status
            <span class="small-text cursor-pointer"><i :class="`fas fa-long-arrow-alt-${$get($store, 'state.approvalSheet.order_by') == 'status' &&
              $get($store, 'state.approvalSheet.order_short') == 'desc'
              ? 'up'
              : 'down'
              }`
              " @click="short('status')"></i></span>
          </div>
          <div class="column15 text-center">
            CSI Score
            <span class="small-text cursor-pointer"><i :class="`fas fa-long-arrow-alt-${$get($store, 'state.myRequest.order_by') == 'csi' &&
              $get($store, 'state.myRequest.order_short') == 'desc'
              ? 'up'
              : 'down'
              }`
              " @click="short('csi')"></i></span>
          </div>
          <div class="column5">Aksi</div>
        </div>
        <div class="request-table-list cursor-pointer" v-for="(item, index) in $store.state.approvalSheet.list"
          :key="index">
          <div class="table-flex mb10" @click="showDetail(item.id)">
            <div class="column10">{{ item.code.toUpperCase() }}</div>
            <div class="column15">{{ $get(item, 'nama_vendor', '') }}</div>
            <div class="column20 ml20">{{ requestType(item.type) }}</div>
            <div class="column15">{{ formatDate(item.createdAt) }}</div>
            <div class="column15">{{ formatDate(item.updatedAt) }}</div>
            <div class="column15">
              <div class="active-box col-elipsis all-column">
                {{ requestStatus(item.status) }}
              </div>
            </div>
            <div class="column15 csiToolTip">
              <span class="csiToolTiptext">{{ requestCsi(item.csi) }}</span>
              <div class="csi-box col-elipsis all-column" v-if="item.status == 5 || item.status == 13">
                <div>
                  <span :class="kinerjaPoRating(item.csi, 1)
                    ? 'star-active'
                    : 'star-deactive'
                    ">&#9733;</span>
                  <span :class="kinerjaPoRating(item.csi, 2)
                    ? 'star-active'
                    : 'star-deactive'
                    ">&#9733;</span>
                  <span :class="kinerjaPoRating(item.csi, 3)
                    ? 'star-active'
                    : 'star-deactive'
                    ">&#9733;</span>
                  <span :class="kinerjaPoRating(item.csi, 4)
                    ? 'star-active'
                    : 'star-deactive'
                    ">&#9733;</span>
                  <span :class="kinerjaPoRating(item.csi, 5)
                    ? 'star-active'
                    : 'star-deactive'
                    ">&#9733;</span>
                </div>
              </div>
            </div>
            <div class="column5 table-flex pointer">
              <i class="far fa-eye icon-hover" @click="
                detail(
                  item.id,
                  item.status,
                  item.type,
                  item.tujuan_pendaftaran,
                  item.approval
                )
                "></i>
              <i class="far fa-star ml10 icon-hover" v-if="(item.status == 5 && $store.state.role_id == 2) ||
                (item.status == 13 && $store.state.role_id == 2)
              " @click="
                submitCsi(item.id, item.status, item.type, item.user_id)
                "></i>
              <!-- <i class="far fa-star"></i> -->
            </div>
          </div>
          <div v-if="detailIndex == item.id">
            <div class="table-flex" v-for="(subItem, i) in item.approval" :key="i">
              <div class="column10">
                <div class="box-green">{{ i + 1 }}</div>
              </div>
              <div class="column20">{{ requestStatus(subItem.status) }}</div>
              <div class="column5">-</div>
              <div class="column60 all-column">
                {{ subItem.desc && checkString(subItem.desc) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="request-pagination">
        <div class="mlp-pagination-wrapper-level1">
          <b-pagination aria-controls="isupplier-table" v-model="page" :total-rows="totalItems" :per-page="perPage"
            align="fill" class="mlp-pagination"></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      requests: [],
      detailIndex: null,
    }
  },
  created() {
    this.getRequest()
  },
  computed: {
    page: {
      get: function () {
        return this.$store.state.approvalSheet.page
      },
      set: function (newValue) {
        this.$store.dispatch('approvalSheet/setPagination', {
          name: 'page',
          value: newValue,
        })
      },
    },
    totalItems: function () {
      return this.$store.state.approvalSheet.totalItems
    },
    perPage: function () {
      return this.$store.state.approvalSheet.perPage
    },
  },
  methods: {
    checkString(value) {
      if (typeof value == 'string') {
        if (value.indexOf('"null"') >= 0) {
          return value.replace(/"null"/g, '')
        }
        if (value.indexOf('""') >= 0) {
          return value.replace(/""/g, '')
        }
        if (value.indexOf('"undefined"') >= 0) {
          return value.replace(/"undefined"/g, '"Tidak ada Catatan"')
        }
        if (value.indexOf('Vendor telah terdaftar di SAP "done"') >= 0) {
          return value.replace(
            /Vendor telah terdaftar di SAP "done"/g,
            'Vendor telah terdaftar di SAP'
          )
        }
        if (value.indexOf('Vendor untuk didaftarkan "done"' >= 0)) {
          return value.replace(
            /Vendor untuk didaftarkan "done"/g,
            'Vendor untuk didaftarkan'
          )
        }
      }
      return value
    },
    async detail(id, status, type, tujuan, items) {
      await this.$store.commit('approvalSheet/SET_DATA', {
        name: 'status',
        value: status,
      })

      if (type == 9 && status == 2) {
        await this.$router.push({
          path: `/approval/detail/${id}/${status}/${type}`,
        })

        return true
      }
      if (
        type == 2 ||
        type == 3 ||
        type == 4 ||
        type == 7 ||
        type == 8 ||
        type == 10 ||
        type == 11
      ) {
        if (type == 2) {
          this.$router.push({
            path: `/approval/review/extend-to-sap/${id}/${status}`,
          })
        }
        if (type == 3) {
          this.$router.push({
            path: `/approval/review/block-vendor/${id}/${status}`,
          })
        }
        if (type == 4) {
          this.$router.push({
            path: `/approval/review/unblock-vendor/${id}/${status}`,
          })
        }
        if (type == 7) {
          switch (status) {
            case 6:
              this.$router.push({
                path: `/approval/k3l-validation/${id}/${status}`,
              })
              break
            case 8:
              this.$router.push({
                path: `/approval/k3l-validation/${id}/${status}`,
              })
              break
            case 15:
              this.$router.push({
                path: `/approval/k3l-validation-oc/${id}/${status}`,
              })
              break
            case 16:
              this.$router.push({
                path: `/approval/k3l-validation-hoc/${id}/${status}`,
              })
              break

            default:
              break
          }
        }

        if (type == 10) {
          switch (status) {
            case 6:
              this.$router.push({
                path: `/approval/k3l-validation/${id}/${status}`,
              })
              break
            case 8:
              this.$router.push({
                path: `/approval/k3l-validation/${id}/${status}`,
              })
              break
            case 15:
              this.$router.push({
                path: `/approval/k3l-validation-oc/${id}/${status}`,
              })
              break
            case 16:
              this.$router.push({
                path: `/approval/k3l-validation-hoc/${id}/${status}`,
              })
              break

            default:
              this.$router.push({
                path: `/approval/review/praqualifikasi-k3l/${id}/${status}/${type}`,
              })
              break
          }
        }

        if (type == 8 || type == 11) {
          switch (status) {
            case 6:
              this.$router.push({
                path: `/approval/kplh-validation/${id}/${status}`,
              })
              break
            case 8:
              this.$router.push({
                path: `/approval/kplh-validation/${id}/${status}`,
              })
              break
            case 18:
              this.$router.push({
                path: `/approval/kplh-validation-hse/${id}/${status}`,
              })
              break
            case 19:
              this.$router.push({
                path: `/approval/kplh-validation-head/${id}/${status}`,
              })
              break
            case 20:
              this.$router.push({
                path: `/approval/kplh-validation/${id}/${status}`,
              })
              break
            case 21:
              this.$router.push({
                path: `/approval/kplh-validation/${id}/${status}`,
              })
              break

            default:
              this.$router.push({
                path: `/approval/review/praqualifikasi-kplh/${id}/${status}/${type}`,
              })
              break
          }
        }
      } else {
        if (this.isValidationPage(status)) {
          if ((tujuan && tujuan == 4) || (tujuan && tujuan == 5)) {
            await this.$router.push({
              path: `/approval/detail/${id}/${status}`,
            })
          } else {
            await this.$router.push({
              path: `/validation/${id}/${status}`,
            })
          }
        } else if (status == 6) {
          let filterForEmail = await items.filter(i => i.status == 8)
          if (filterForEmail && filterForEmail.length > 0) {
            await this.$router.push({
              path: `/approval/detail/${id}/${status}`,
              // query: { status: 'email-valid' },
            })
          } else {
            await this.$router.push({
              path: `/approval/detail/${id}/${status}`,
            })
          }
        } else if (status == 13) {
          await this.$store.commit(
            'SET_NOTIF',
            'Vendor telah terdaftar di Isupplier'
          )
        } else if (status == 14) {
          await this.$store.commit(
            'SET_NOTIF',
            'Vendor telah dihapus, tidak ada data'
          )
        } else if (status == 10) {
          let filterRole = await items.filter(i => i.status == 9)
          if (filterRole && filterRole.length > 0) {
            await this.$router.push({
              path: `/approval/detail/${id}/${status}`,
              query: { id: '625d1d1efb9f82520177cf84' },
            })
          } else {
            await this.$router.push({
              path: `/approval/detail/${id}/${status}`,
              query: { id: '625d1cdf0a0d2036f61b3215' },
            })
          }
        } else if (status == 11) {
          let filterRole = await items.filter(i => i.status == 9)
          if (filterRole && filterRole.length > 0) {
            await this.$router.push({
              path: `/approval/detail/${id}/${status}`,
              query: { id: '625d1d1efb9f82520177cf84' },
            })
          } else {
            await this.$router.push({
              path: `/approval/detail/${id}/${status}`,
              query: { id: '625d1cdf0a0d2036f61b3215' },
            })
          }
        } else {
          await this.$router.push({ path: `/approval/detail/${id}/${status}` })
        }
      }
    },
    async getRequest() {
      let userCompany = this.$store.state.kode

      if (userCompany && userCompany.length > 0) {
        userCompany = userCompany.map(item => {
          return item.kode
        })
        userCompany = userCompany.join(',')
        await this.$store.commit('approvalSheet/SET_DATA', {
          name: 'company_code',
          value: userCompany,
        })
      }

      await this.$store.dispatch('approvalSheet/getApproval')
    },
    showDetail(value) {
      if (this.detailIndex == null || this.detailIndex != value) {
        this.detailIndex = value
      } else {
        this.detailIndex = null
      }
    },
    async short(order) {
      await this.$store.commit('approvalSheet/SET_ORDER_SHORT')
      await this.$store.commit('approvalSheet/SET_DATA', {
        name: 'order_by',
        value: order,
      })
      await this.getRequest()
    },
    submitCsi(id, status, type, userid) {
      this.$router.push(`/myrequest/csi/${id}/${type}/${status}/${userid}`)
    },
  },
}
</script>
